<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Plantillas</h2>
          <p>
            En este apartado se pueden visualizar las plantillas.<br />
            Las plantillas son los moldes de los productos, aquello que define
            su diseño y cómo interactuarán los usuarios con él (a través de los
            atributos y selectores).
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de plantillas</h3>
              <v-server-table
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <!-- <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{ name: 'AdminProductTemplatesNewScreen' }"
                    >Nuevo selector</b-button
                  > -->

                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  > -->
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.reference)"
                    @change="toggleCell($event, props.row.reference)"
                  />
                </div>

                <template v-slot:characteristics="props">
                  <span
                    >{{ props.row.definition.views.length }} vistas,
                    {{ props.row.definition.attributes.length }} atributos</span
                  >
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminProductTemplatesEditScreen',
                      params: { reference: props.row.reference },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    >Detalles</b-button
                  >

                  <!-- <b-button
                    @click="removeProductSelector(props.row.reference)"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    >Eliminar</b-button
                  > -->
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'AdminProductTemplatesScreen',
  props: {},
  components: {},
  data() {
    return {
      table: {
        url: uris.productTemplatesURI,
        selected: [],
        allSelected: false,
        columns: ['reference', 'characteristics', 'actions'],
        options: {
          sortable: ['name_es'],
          headings: {
            reference: 'Referencia',
            characteristics: 'Características',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  methods: {
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeProductSelector(x);
      });
    },
    removeProductSelector(reference) {
      actions.deleteProductSelector(reference).then((x) => {
        this.$refs.table.refresh();
      });
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
